import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  tag_colorTagPendingTextHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_4xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const modal = css`
  .BaseModal-Content.popup {
    width: 640px;
    max-width: 92vw;
  }

  &.ConfirmUnassignCardModal .BaseModal-Body {
    padding: ${spacing(10)};
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
  }
`

export const title = css`
  margin: 0;
  ${font_4xl};
  font-family: ${font_family_weight_medium};
  font-weight: 500;
  color: ${text_colorTextPrimary};
`

export const subtitle = css`
  margin: 0;
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
`

export const summaryCard = css`
  background-color: ${base_colorSurfaceSecondary};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(3)};
  padding: ${spacing(5)};
  display: flex;
  flex-direction: column;
`

export const identity = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
  min-width: 0;
  padding-bottom: ${spacing(4)};
`

export const identityText = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const identityName = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const identityEmail = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const divider = css`
  height: 1px;
  background-color: ${base_colorContentBorder};
  margin-bottom: ${spacing(3)};
`

export const caption = css`
  ${font_sm};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextSecondary};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding-bottom: ${spacing(2)};
`

export const cardRow = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(3)};
  padding: ${spacing(2)} 0;
  color: ${text_colorTextPrimary};
`

export const cardIdentity = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
  min-width: 0;
`

export const cardName = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const warningIcon = css`
  path {
    fill: ${tag_colorTagPendingTextHover};
  }
`

export const footer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(5)};
  margin-top: ${spacing(2)};
`

export const cancelButton = css`
  &.Button.no-shell {
    box-shadow: none;
    color: ${text_colorTextSecondary};
  }
`

export default {
  modal,
  title,
  subtitle,
  summaryCard,
  identity,
  identityText,
  identityName,
  identityEmail,
  divider,
  caption,
  cardRow,
  cardIdentity,
  cardName,
  warningIcon,
  footer,
  cancelButton,
}
